export default __webpack_public_path__ + "static/media/solucao-07.8a69de5b.webp";